export default __webpack_public_path__ + "static/media/escritorio.58066481.png";